
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-9008ea02&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AddNewInventory.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./AddNewInventory.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-9008ea02!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AddNewInventory.vue"),
  /* scopeId */
  "data-v-9008ea02",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Inventory/AddNewInventory.vue
// module id = 593
// module chunks = 0